import { initSlider } from "components/jiffy/jiffytransfers-landing-v2/ui";
import "./transfers-styles-section.scss";

document.addEventListener("DOMContentLoaded", () => {
  initSlider({
    containerSelector: ".js-jiffytransfers-landing-v2-transfers-styles-section-swiper",
    spaceBetween: 24
  });
});
